module.exports = __webpack_public_path__ + "static/media/IB.d4d84f4b.png";